import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import isEmpty from 'lodash.isempty';
import { MEASURE } from '../../../constants/reading/MeasuresConstants';
import ProbeDetailsBodyContainer from '../../../providers/probeDetails/reading/ProbeDetailsBodyContainer';
import TrcProbeDetailsContainer from '../../../providers/probeDetails/reading/trc/TrcProbeDetailsContainer';
import OlProbeDetailsContainer from '../../../providers/probeDetails/reading/ol/OlProbeDetailsContainer';
import TroProbeDetailsContainer from '../../../providers/probeDetails/reading/tro/TroProbeDetailsContainer';
import VocaboProbeDetailsContainer from '../../../providers/probeDetails/reading/vocabo/VocaboProbeDetailsContainer';
import DecodingProbeDetailsContainer from '../../../providers/probeDetails/reading/do/DecodingProbeDetailsContainer';
import DecodeProbeDetailsContainer from '../../../providers/probeDetails/reading/decode/DecodeProbeDetailsContainer';

const { TRC, TRO, DO, OL, VOCABO, AP, LC, RW, IW } = MEASURE;
const PROBE_DETAILS_BODY_RENDER_KEYS = {
    TRC,
    OL,
    TRO,
    DO,
    VOCABO,
    AP,
    LC,
    RW,
    IW,
};

const PROBE_DETAILS_BODY_RENDER = {
    renderTRCBody: (result, student) => (
        <TrcProbeDetailsContainer student={student} result={result} />
    ),
    renderOLBody: result => <OlProbeDetailsContainer result={result} />,
    renderTROBody: result => <TroProbeDetailsContainer result={result} />,
    renderDOBody: result => <DecodingProbeDetailsContainer result={result} />,
    renderVOCABOBody: result => <VocaboProbeDetailsContainer result={result} />,
    renderAPBody: result => <DecodeProbeDetailsContainer result={result} />,
    renderLCBody: result => <DecodeProbeDetailsContainer result={result} />,
    renderRWBody: result => <DecodeProbeDetailsContainer result={result} />,
    renderIWBody: result => <DecodeProbeDetailsContainer result={result} />,
};

const ProbeDetailsRenderBody = ({
    measure,
    probeDetailLookerEvent,
    student,
    result,
    currentSubtab,
}) => {
    useEffect(() => {
        probeDetailLookerEvent(measure, student.externalId, currentSubtab);
    }, []);

    if (isEmpty(student) || isEmpty(result)) return null;

    return get(PROBE_DETAILS_BODY_RENDER_KEYS, measure) ? (
        PROBE_DETAILS_BODY_RENDER[`render${PROBE_DETAILS_BODY_RENDER_KEYS[measure]}Body`](
            result,
            student,
        )
    ) : (
        <ProbeDetailsBodyContainer result={result} />
    );
};

ProbeDetailsRenderBody.defaultProps = {
    student: {},
    result: {},
    measure: null,
    probeDetailLookerEvent: () => {},
    currentSubtab: '',
};

ProbeDetailsRenderBody.propTypes = {
    student: PropTypes.object,
    result: PropTypes.object,
    measure: PropTypes.string,
    probeDetailLookerEvent: PropTypes.func,
    currentSubtab: PropTypes.string,
};

export default ProbeDetailsRenderBody;
